export default {
  'awb.field.awb_number': 'AWB Number',
  'awb.field.airline_prefix': 'Airline Prefix',
  'awb.field.serial_number': 'Serial Number',
  'awb.field.status': 'Status',
  'awb.field.issued_date': 'Issued Date',
  'awb.field.used_date': 'Used Date',
  'awb.field.shipment': 'Shipment',
  'awb.field.remarks': 'Remarks',
  'awb.field.action': 'Action',
  'awb.add_awb.tooltip': 'Add AWB',
  'awb.delete.confirm.title': 'Are you sure to delete this AWB?',
  'awb.deleted.success': 'Successfully deleted AWB',
  'awb.delete.tooltip': 'Delete AWB',
  'awb.added.success': 'Successfully added AWB',
  'awb.updated.success': 'Successfully updated AWB',
  'awb.edit_awb.tooltip': 'Edit AWB',
  'awb.validation.airline_prefix': 'Please enter a valid 3-digit airline prefix',
  'awb.validation.from_number': 'Please enter a valid 8-digit from number',
  'awb.validation.to_number_or_count': 'Please provide either To Number or Count (or both)',
  'awb.preview.found_existing_count': 'Found {count} AWB number(s) that already exist in database',
  'awb.preview.found_valid_count': 'Found {count} valid AWB numbers',
  'awb.preview.error': 'Failed to preview AWB numbers',
  'awb.preview.cannot_generate_awb_numbers':
    'Cannot generate AWB numbers that already exist. Please adjust your range.',
  'awb.preview.successfully_generated':
    'Successfully generated {count} AWB numbers from {from_number} to {to_number}',
  'awb.preview.generate_awb_numbers': 'Generate {count} AWB Numbers',
  'awb.field.from_number': 'From Number',
  'awb.field.to_number': 'To Number',
  'awb.field.count': 'Count',
  'awb.preview.preview_awb_numbers': 'Preview AWB Numbers',
  'awb.preview.conflict_detected': 'Conflict Detected',
  'awb.preview.conflict_detected_description':
    '{count} AWB number(s) already exist in the database. Please adjust your range or remove existing numbers.',
  'awb.preview.generation_settings': 'Generation Settings',
  'awb.preview.limit_number_of_awb_numbers':
    'Limit the number of AWB numbers to generate. If To Number is also provided, will return first N numbers in the range.',
  'awb.field.status.available': 'Available',
  'awb.field.status.used': 'Used',
  'awb.message.ready_to_generate': 'Ready to generate',
  'awb.message.generate_awb_numbers': 'Generate {count} AWB Numbers',
};
